import request from "./curl";
import media_utility from "./media_utility";

export default {
  name: "content_forward_dialog",
  props:['showDialog', 'data'],
  data: () => ({
    groups:[],
    isUpdating:false,
    autoUpdate: true,
    friends:[],
    text_msg:'',
    message_content_type:null,
    message_content_id:null,
    snackbar:false,
    err_msg:'',
    searchInput:null

  }),
  computed: {
    dialog:{
      get:function(){
        this.friends=[];
        this.share_send_data_set();
        return this.showDialog;
      },
      set:function(value){
        this.$emit("dialogClose", value);
      }
    },
    async getChatgrpList(){
      return await this.$store.getters.getChatgrpList;
    },
    userData() {
      return this.$store.getters.userData;
    },
    get_groups_sorted: function() {
      function compare(a, b) {
        if (a.group_name.toLowerCase() < b.group_name.toLowerCase())
          return -1;
        if (a.group_name.toLowerCase() > b.group_name.toLowerCase())
          return 1;
        return 0;
      }

      return this.groups.sort(compare);
    }
  },
  mounted() {
    this.get_groups();
    this.getUserContactList();
  },
  methods: {
    /**
     * get_groups
     *
     */
    async get_groups() {
      //get chargrp list from localstorage first and render it
      let chatgrp_ls = await this.getChatgrpList;
      chatgrp_ls.forEach((group)=>{
        if(group != null){
          var group_data = [];
          group_data.is_group = true;
          group_data.group_icon = group.group_icon;
          group_data.group_id = group.group_id;
          group_data.group_name = group.group_name;

          if(group.type == '1' || group.type == '21'){
            group_data.type_icon = "mdi-account-multiple"
          }
          else{
            group_data.type_icon = "mdi-account"
          }

          // push for all groups
          this.groups.push(group_data);
        }
      });
    },
    /**
     * remove
     */
    remove (item) {
      let index = this.friends.findIndex(group =>  group.group_id=== item.group_id);
      if (index >= 0) this.friends.splice(index, 1)
    },
    /**
     * share_send_data_set
     */
    share_send_data_set(){
      this.text_msg = this.data.text_msg;
      if(this.data.message_content_type && this.data.message_content_type == 1){ 
        // 1 is media message 
        this.message_content_type = this.data.message_content_type;
        this.message_content_id = this.data.message_content_id;
      }
    },
    /**
     * message_forward
     */
    async message_forward(){
      if(this.friends.length <= 0){
        this.err_msg =  'Please select atleast one group or user.'
        this.snackbar = true;
        return;
      }

      let grp_details = await this.getChatgrpList;
      var forward_data = new FormData();
      forward_data.append("chat_user_id", this.userData.user_id);
      var group_data = [];
      var i = 0;
      this.friends.forEach((group) => {
        group_data[i] = {};
        group_data[i]['type'] = group.is_group;
        group_data[i]['group_id'] = group.group_id;
        //check one to one
        let one_to_one_group = this.check_if_one_to_one_group_exists(group.group_id, grp_details);
        if(one_to_one_group){
          //if user id or participan is allredy one to one then set 1 is for group
          group_data[i]['type'] = 1;
          group_data[i]['group_id'] = one_to_one_group;
        }

        i++;
      });

      forward_data.append('group_data', JSON.stringify(group_data));
      forward_data.append("text_msg", this.text_msg);
      
      if(this.message_content_type && this.message_content_id){
        forward_data.append("message_content_type", this.message_content_type);
        forward_data.append("message_content_id", this.message_content_id);
      }
      
      request.curl(this, "message_forward", forward_data)
        .then(response => {
          this.err_msg =  response.resp_msg;
          this.snackbar = true;
          if(response.resp_status){
            setTimeout(()=>{
              this.dialog = false;
            }, 1000);
          }
        });
    },
    /**
     * getUserContactList
     */
    getUserContactList(){
      var data = new FormData();
      data.append("chat_user_id", this.userData.user_id);

      request.curl(this, "user_contact_list", data).
      then(response => {
        if(response.resp_status){
          let user_contact_list = response.resp_data;
          user_contact_list.forEach((contact) => {
            let group_data = {};
            group_data.is_group = false;
            group_data.group_icon = contact.image;
            group_data.group_id   = contact.contact_id;
            group_data.group_name = contact.user_name;
            this.groups.push(group_data);
          })
        }
      });
    },
    /**
     * check_if_one_to_one_group_exists
     */
    check_if_one_to_one_group_exists(participant_id, grp_details) {
      let one_to_one_group = false;
      grp_details.forEach((group)=>{
        if(group.type == 0){
          if(group.participants && group.participants != null){
            let participants = group.participants.split(',');
            let isPresent = participants.some((id) => {return id === participant_id});
            if(isPresent){
              one_to_one_group = group.group_id;
              return;
            }
          }
        }
      });

      return one_to_one_group;
    },
    /*
    * checkStrFirstCharHasAlphabet
    * */
    checkStrFirstCharHasAlphabet(str){
      if(/^[A-Za-z]/.test(str)) {
        return true;
      }
      return false;
    },
    /*
    * get_group_icon
    * */
    get_group_icon(group, group_icon_data){      
      return media_utility.get_group_icon(group, group_icon_data);
    }
  }
}
